import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';
import { Brush, Calculator, Palette, Shield, Sun, Users } from '../ui/Icons';

const REASONS = [
  {
    title: 'Uncompromising quality',
    copy: 'Every batch is tested against the same benchmarks before it leaves the plant — consistent colour, consistent film.',
    icon: Shield,
  },
  {
    title: 'Proven durability',
    copy: 'UV-stable pigments and water-resistant binders keep walls from chalking, fading or flaking through the seasons.',
    icon: Sun,
  },
  {
    title: 'Premium finish',
    copy: 'Fine-ground formulations level out smoothly, so you get an even, professional surface with fewer coats.',
    icon: Brush,
  },
  {
    title: 'Wide colour range',
    copy: 'From quiet neutrals to saturated statements — over 1,800 shades, matched accurately at the counter.',
    icon: Palette,
  },
  {
    title: 'Professional service',
    copy: 'Trained applicators, surface prep done properly, and a site left clean when the job is finished.',
    icon: Users,
  },
  {
    title: 'Guidance that helps',
    copy: 'Colour consultants and a cost calculator help you plan the job before a single tin is opened.',
    icon: Calculator,
  },
];

const WhyChooseVertex = () => (
  <section className="vp-section bg-white">
    <div className="container">
      <SectionHeading
        eyebrow="Why Vertex Paints"
        title="Six reasons homeowners keep coming back"
        lead="A paint job is only as good as what goes into the tin — and who puts it on the wall. We take both seriously."
        className="mb-12"
      />

      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
        {REASONS.map((r, i) => {
          const Icon = r.icon;
          return (
            <Reveal as="li" key={r.title} delay={Math.min(i % 3, 4) as 0 | 1 | 2 | 3 | 4}>
              <div className="vp-card group relative h-full p-6 lg:p-7 !rounded-2xl">
                {/* accent bar */}
                <span className="absolute left-0 top-7 h-8 w-[3px] rounded-r bg-gradient-to-b from-brand-red to-brand-blue scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500 ease-premium" />
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-brand-blue to-brand-red text-white flex items-center justify-center shadow-blue">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 text-lg font-semibold text-brand-ink">{r.title}</h3>
                <p className="mt-2.5 text-sm text-brand-muted leading-relaxed">{r.copy}</p>
              </div>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);

export default WhyChooseVertex;
